import { createContext, useContext } from 'react';

import type { OrganizationAccessContextValue } from '@/shared/components/organization/organizationAccess';

const defaultContextValue: OrganizationAccessContextValue = {
  isError: false,
  organization: undefined,
  globalRoles: [],
  ownRole: undefined
};

export const OrganizationAccessContext =
  createContext<OrganizationAccessContextValue>(defaultContextValue);

/**
 * Returns the precomputed permission context value for the organization
 * currently provided by the nearest {@link OrganizationAccessProvider}. Falls
 * back to a neutral (denied) context value when used outside a provider.
 */
export const useOrganizationAccessContextValue =
  (): OrganizationAccessContextValue => useContext(OrganizationAccessContext);
